export default __webpack_public_path__ + "static/media/folder.0d58fbd3.svg";